import {gql} from '@apollo/client';

export const SAVE_SORTER_PLAN = gql`
    mutation SaveSorterPlan($input: SaveSorterPlanInput!) {
        saveSorterPlan(input: $input) {
            id
            sorterId
            warehouseId
            sorterPlanName
            status
            version
            isDropBag
            isSpecified
            printCount
            createdAt
            createdBy
            updatedAt
            updatedBy
        }
    }
`;

